export const purposeOfCall = [
  {
    id: '95670eaa-cb7e-4be4-84a5-5b7c3f7f9594',
    index: 1,
    name: 'Loading / Discharging of Cargo',
    slug: 'loading-discharging-of-cargo'
  },
  {
    id: 'e40dce8d-712d-4cd7-87d1-d52fcb13fe6b',
    index: 2,
    name: 'Embarking / Disembarking Passengers',
    slug: 'embarking-discharging-passengers'
  },
  {
    id: 'd5cd797a-044e-4ffd-9570-861c1d886318',
    index: 3,
    name: 'Taking Bunkers',
    slug: 'taking-bunkers'
  },
  {
    id: '1fa35175-4b9f-4bc2-8011-997e6be43623',
    index: 4,
    name: 'Changing Members of Crew',
    slug: 'changing-members-of-crew'
  },
  {
    id: 'a2ce0f9a-44d8-435d-a287-e6868980c615',
    index: 5,
    name: 'Goodwill visit',
    slug: 'goodwill-visit'
  },
  {
    id: 'f13fe7ea-f98d-4a90-9bbc-b589262a8769',
    index: 6,
    name: "Taking Ship's Supplies",
    slug: 'taking-ship-supplies'
  },
  {
    id: 'a76f67bb-6cc5-4afc-9ce3-ed39d04db208',
    index: 7,
    name: 'Repair',
    slug: 'repair'
  },
  {
    id: '8ee6b88e-0fae-4f6d-8391-280842c1e373',
    index: 8,
    name: 'Laid-up',
    slug: 'laid-up'
  },
  {
    id: '5569b2d6-02a4-4c64-adc8-3839081a9e03',
    index: 9,
    name: 'Awaiting orders',
    slug: 'awaiting-orders'
  },
  {
    id: 'fc8ed1c7-5997-4b31-b91a-372c10cfcc8a',
    index: 10,
    name: 'Miscellaneous',
    slug: 'miscellaneous'
  },
  {
    id: 'e6e779bc-73ae-44a1-9d32-dae30f595faa',
    index: 11,
    name: 'Crew movement',
    slug: 'crew-movement'
  },
  {
    id: '9412dc3d-d94b-4c1a-b4db-20084a465489',
    index: 12,
    name: 'Cruise / leisure / recreation',
    slug: 'cruise-leisure-recreation'
  },
  {
    id: '48043ce0-4362-41a7-ac71-b995717b9219',
    index: 13,
    name: 'Under government order',
    slug: 'under-government-order'
  },
  {
    id: 'ad7d36e1-f32d-4f44-8ef0-f37ca46b5967',
    index: 14,
    name: 'Quarantine inspection',
    slug: 'quarantine-inspection'
  },
  {
    id: '1e686321-2be2-4236-adc0-0d5dcca14c35',
    index: 15,
    name: 'To seek protection',
    slug: 'to-seek-protection'
  }
];

export const vesselCallStatuses = [
  {
    id: '4b7d429c-8a9a-4fce-b98f-fb29fd24f109',
    index: 1,
    name: 'Created',
    slug: 'created'
  },
  {
    id: '538c71ad-2da7-4a78-9890-032955aa8eb2',
    index: 2,
    name: 'Due To Arrive',
    slug: 'due-to-arrive'
  },
  {
    id: '0c6d5eeb-9e02-421d-9396-5e8be87f7f89',
    index: 3,
    name: 'In Port',
    slug: 'in-port'
  },
  {
    id: '7caeedf7-2bfa-4c9e-9dce-3048dd63e7a8',
    index: 4,
    name: 'Due To Depart',
    slug: 'due-to-depart'
  },
  {
    id: '950d679b-53bc-4285-917a-6ce155069d48',
    index: 5,
    name: 'Departed',
    slug: 'departed'
  }
];

export const declarationStatuses = [
  {
    id: '7dc67029-6862-46bc-9e07-457d57fd944d',
    index: 1,
    name: 'Created',
    slug: 'created'
  },
  {
    id: '97592006-2652-4a97-b6a0-1f5ded1b92b0',
    index: 2,
    name: 'Submitted',
    slug: 'submitted'
  },
  {
    id: 'c4a61771-59cb-42cc-bfda-8f213b0bd6a1',
    index: 3,
    name: 'Approved',
    slug: 'approved'
  },
  {
    id: 'd740ca0f-06cd-481b-a238-154bda326b61',
    index: 4,
    name: 'Withdrawn',
    slug: 'withdrawn'
  }
];
